"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullScreenOverlay = exports.Overlay = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
tslib_1.__exportStar(require("./typings"), exports);
var Overlay_1 = require("./Overlay");
Object.defineProperty(exports, "Overlay", { enumerable: true, get: function () { return Overlay_1.Overlay; } });
var FullScreenOverlay_1 = require("./FullScreenOverlay");
Object.defineProperty(exports, "FullScreenOverlay", { enumerable: true, get: function () { return FullScreenOverlay_1.FullScreenOverlay; } });
//# sourceMappingURL=index.js.map